export interface IRetornoBuscaCepDTO {
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  ibge: string;
  erro?: boolean;
}
export async function buscaCep(cep: string): Promise<IRetornoBuscaCepDTO> {
  try {
    const response = await fetch(`https://opencep.com/v1/${cep}`);

    if (response.ok) {
      const resultado = await response.json();
      if (resultado.erro) throw new Error('CEP Inválido');

      const { logradouro, bairro, localidade, uf, ibge, estado } = resultado;

      return {
        logradouro,
        bairro,
        localidade,
        uf,
        estado,
        ibge,
      } as IRetornoBuscaCepDTO;
    }
    return { erro: true } as IRetornoBuscaCepDTO;
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    return { erro: true } as IRetornoBuscaCepDTO;
  }
}
